<template>
  <div class="order_box">
    <div class="page_title order_title">
      <custom-breadcrumb/>
    </div>
    <div class="search-box">
      <el-select
        v-model="selectData.type"
        clearable
        placeholder="Type"
        @change="changSelectHandel()"
      >
        <el-option
          v-for="item in typeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        style="margin-left:20px"
        v-model="selectData.status"
        clearable
        placeholder="Refund Status"
        @change="changSelectHandel()"
      >
        <el-option
          v-for="item in statusList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div class="date_text">Create Time</div>
      <el-date-picker
        v-model="defalutValue"
        type="daterange"
        align="right"
        value-format="yyyy-MM-dd"
        start-placeholder="Start Date"
        end-placeholder="End Date"
        @change="changeDateRange">
      </el-date-picker>
      <el-input
        class="search_input"
        v-model="selectData.keyWords"
        prefix-icon="el-icon-search"
        placeholder="Search orders by order,SKU,Product Name,Retailer Email"
        clearable
      />
      <el-button type="primary" class="search-btn" @click="changSelectHandel()"
        >Search</el-button
      >
    </div>
    <div class="page_table">
      <el-table :data="serviceOrderList"  height="calc(100vh - 310px)" stripe style="width: 100%;margin-top:20px; height: calc(100vh - 310px);">
        <el-table-column
          prop="createdAt"
          label="Create Time/Service Order ID"
          width="220"
        >
          <template slot-scope="scope">
            <span style="color:#707070">{{ scope.row.createAt }}</span>
            <span>{{ scope.row.sid }}</span>
          </template>
        </el-table-column>
        <el-table-column  label="Order ID" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.orderId }}</span>
          </template>
        </el-table-column>
        <el-table-column  label="Retailer" width="220">
          <template slot-scope="scope">
            <img
              v-if="scope.row.userSource == 1"
              class="little_logo"
              src="https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-logo.png"
              alt=""
            />
            <span>{{ scope.row.retailerName }}</span>
            <br>
            <span>{{scope.row.remark}}</span>
          </template>
        </el-table-column>
        <el-table-column  label="Type" width="150">
          <template slot-scope="scope">
            <span>{{ getType(scope.row.type) }}</span>
          </template>
        </el-table-column>
        <el-table-column  label="Refund Status" width="160">
          <template slot-scope="scope">
            <span>{{ getStatus(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column  label="Action" width="350">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status == 1"
              type="primary"
              class="action_button"
              :loading="actionLoading"
              @click="showReviewDialog(true,scope.row.sid)"
              >Pass</el-button
            >
            <el-button
              v-if="scope.row.status == 1"
              type="primary"
              class="action_button"
              :loading="actionLoading"
              @click="showReviewDialog(false,scope.row.sid)"
              >Reject</el-button
            >
            <el-button
              v-if="scope.row.status == 3"
              type="primary"
              class="action_button"
              @click="showArbitrationVisible(scope.row.sid)"
              >Submission of Vouchers</el-button
            >
            <el-button
              type="primary"
              class="action_button"
              @click="gotoRefund(scope.row.sid)"
              >View</el-button
            >
          </template>
        </el-table-column>
        <el-table-column  label="Total" width="100">
          <template slot-scope="scope">
            <span>${{(scope.row.refundTotalAmount).toFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column  label="Brand" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.brandName }}</span>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        :currentPage="selectData.pageNo"
        :total="selectData.total"
        :pageSize="selectData.pageSize"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></Pagination>
    </div>
    <review-dialog :reviewVisible="reviewVisible" :action="action" :reason="reason" @back="back" @reviewServiceOrder="reviewServiceOrder"/>
    <arbitration-dialog :arbitrationVisible="arbitrationVisible" :serviceOrderId="serviceOrderId" @backArbitrationVisible="backArbitrationVisible" @loadData="loadData"/>
  </div>
</template>

<script>
import { postAction, getAction, putAction } from '@/api/manage.js'
import Pagination from '../../components/pagination.vue'
import ReviewDialog from './components/review-dialog.vue'
import ArbitrationDialog from './components/arbitration-dialog.vue'
import CustomBreadcrumb from '../../components/custom-breadcrumb'
export default {
  components: { Pagination, ReviewDialog, ArbitrationDialog, CustomBreadcrumb },
  data() {
    return {
      action: false,
      reviewVisible: false,
      arbitrationVisible: false,
      defalutValue: '',
      selectData: {
        keyWords: '',
        startDateValue: '',
        endDateValue: '',
        type: '',
        status: '',
        pageSize: 20,
        pageNo: 1
      },
      serviceOrderList: [],
      statusList: [
        {label: 'In Reveiw', value: 1},
        {label: 'Refunding', value: 2},
        {label: 'To Arbitrate', value: 3},
        {label: 'Complete', value: 4},
        {label: 'Close', value: 5},
        {label: 'Submit', value: 6},
        {label: 'To be Returned', value: 7},
        {label: 'Brand Rejection', value: 60},
        {label: 'Operate Refused', value: 61},
        {label: 'Start To Arbitrate', value: 30},
        {label: 'Platform To Arbitrate', value: 31},
        {label: 'Brand To Arbitrate', value: 32},
        {label: 'To Arbitrate Result', value: 33}
      ],
      typeList: [
        {label: 'Refund', value: 1}
      ],
      serviceOrderId: '',
      actionLoading: false,
      reason: ''
    }
  },
  created() {
    // 获取是否有orderDetailId 如果有则查询指定orderDetail相关售后单
    const orderDetailId = this.$route.query.orderDetailId
    const skuId = this.$route.query.skuId
    if (orderDetailId) {
      this.selectData.orderDetailId = orderDetailId
    }
    if (skuId) {
      this.selectData.keyWords = skuId
    }

    this.loadData()
  },
  methods: {
    /**
     * 审核
     */
    reviewServiceOrder(reason) {
      this.actionLoading = true
      const params = {reason: reason}
      putAction('/order/api/v0.2/service-orders/review/' + this.serviceOrderId + '/' + this.action, params).then(response => {
        if (response.success) {
          this.actionLoading = false
          this.reason = ''
          this.back()
          this.loadData()
        } else {
          this.$message.warning(response.message)
          this.actionLoading = false
        }
      }).catch(err => {
        this.$message.warning(err)
        this.actionLoading = false
      })
    },
    backArbitrationVisible() {
      this.arbitrationVisible = false
    },
    back() {
      this.reviewVisible = false
    },
    showArbitrationVisible(id) {
      this.serviceOrderId = id
      this.arbitrationVisible = true
    },
    // 审核通过或者拒绝弹框
    showReviewDialog(action, id) {
      this.serviceOrderId = id
      this.action = action
      this.reviewVisible = true
    },
    /**
     * 去详情
     */
    gotoRefund(serviceOrderId) {
      this.$router.push({path: '/menu/service-order-detail', query: {serviceOrderId: serviceOrderId}})
    },
    changeDateRange(value) {
      this.selectData.startDateValue = ''
      this.selectData.endDateValue = ''
      if (value) {
        this.selectData.startDateValue = value[0]
        this.selectData.endDateValue = value[1]
      }
      this.loadData()
    },
    changSelectHandel() {
      this.loadData()
    },
    handleSizeChange(val) {
      this.selectData.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.selectData.pageNo = val
      this.loadData()
    },
    loadData() {
      console.log(this.selectData)
      getAction('/order/api/v0.2/service-orders/brand/list', this.selectData).then(response => {
        if (response.success) {
          this.serviceOrderList = response.result.records
          this.selectData.total = response.result.total
        } else {
          this.$message.warning(response.message)
        }
      }).catch(err => {
        this.$message.warning(err.message)
      })
    },
    getStatus(statusCode) {
      let statusObject = this.statusList.filter(element => {
        return statusCode === element.value
      })
      return statusObject[0].label
    },
    getType(typeCode) {
      if (typeCode === 1) {
        return 'Refund'
      }
    }
  }
}
</script>

<style lang="less" scoped>
.action_button {
  background-color: #262b2f;
  border-color: #262b2f;
  min-width: 74px;
  width: auto;
  height: 30px;
  padding: 0 10px !important;
}
.order_title{
  margin: 0px 30px 20px 0px !important;
  height: 35px;
  line-height: 35px;
  margin-right: 0px !important;
}
/deep/.cell {
  font-size: 14px;
  font-family: Avenir;
  font-weight: 500;
  color: #000000;
}
.el-button--primary,
.el-button--primary:focus,
.el-button--primary:hover {
  background-color: #262b2f !important;
  border-color: #262b2f !important;
}
/deep/ .el-range-input{width:40%}
/deep/ .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner{width:300px}
/deep/ .el-tabs__active-bar {
  background-color: #262b2f !important;
}
.search-box {
  width: 96%;
  display: flex;
  margin: 20px 0 0 0;
  height: 40px;
  .date_text {
    width: 120px;
    height: 40px;
    border: 1px solid #dcdfe6;
    line-height: 40px;
    text-align: center;
    color: #8f8f8f;
    border-right: none;
    margin-left: 16px;
  }
}
.search-btn {
  background-color: #262b2f;
  border-color: #262b2f;
  width: 100px;
  border-radius: 0;
}
.search_input {
  width: 40%;
  margin-left: 16px;
}
.page_table {
  width: 100%;
  /deep/ .pageSize{

  }

}
.little_logo {
  width: 13px;
  height: 13px;
  margin-right: 2px;
}
.memo{
  width: 16px;
  cursor: pointer;
  img{
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/service-order/service-order-list.vue